import NextLink from 'next/link'
import styled from 'styled-components'

import { theme } from 'src/styles'

interface AnchorProps {
    readonly $size: string
    readonly $color: string
}

const { fontSizes, colors, space, radii, sizes, borderWidths, fontWeights } = theme

const getButtonSize = size => {
    switch (size) {
        case 'sm':
            return `
                height: ${space['spacing-xl']};
                min-height: ${space['spacing-xl']};
                font-size: ${fontSizes['font-size-button-small']};
            `
        case 'lg':
            return `
                height: ${space['spacing-mega']};
                min-height: ${space['spacing-mega']};
                font-size: ${fontSizes['font-size-body-2']};
            `
        case 'full':
            return `
                width: 100%;
                border-radius: ${radii['corner-radius-none']};
                height: auto;
                padding: ${space['spacing-lg']} ${space['spacing-sm']};
                justify-content: center;
                font-size: ${fontSizes['font-size-body-2']};
            `
        default:
            return `
                height: ${space['spacing-xxl']};
                minHeight: ${space['spacing-xxl']};
            `
    }
}

const getButtonColor = color => {
    switch (color) {
        case 'white':
            return `
                background: ${colors['neutral-background-default']};
                color: ${colors['primary-text-default']};
                border: ${borderWidths['border-stroke-micro']} solid ${colors['primary-border-default']};
            `
        default:
            return `
                background: ${colors['blue-background-strong-default']};
                color: ${colors['blue-text-strong']};
            `
    }
}

const getButtonHover = color => {
    switch (color) {
        case 'white':
            return `
                background-color: ${colors['primary-background-strong-hover']};
                color: ${colors['primary-text-strong']};
            `
        default:
            return `
                background: ${colors['blue-background-strong-hover']};
            `
    }
}

export const StyledAnchor = styled(NextLink)<AnchorProps>`
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    gap: ${space['spacing-lg']};
    padding: 0 ${space['spacing-sm']};
    border-radius: ${radii['corner-radius-sm']};
    font-weight: ${fontWeights['font-weight-medium']};
    ${props => getButtonSize(props.$size)}
    ${props => getButtonColor(props.$color)}

    &:hover {
        ${props => getButtonHover(props.$color)}
    }

    &:hover::after {
        content: unset;
    }

    span {
        width: ${sizes['spacing-md']};
        height: ${sizes['spacing-md']};

        path {
            fill: ${colors['blue-text-strong']};
        }
    }
`
